import ApiClient from '../ApiClient';

class TwilioChannel extends ApiClient {
  constructor() {
    super('channels/twilio_channel', { accountScoped: true });
  }

  toggleRecordAudio(payload) {
    return axios.put(`${this.url}`,payload);
  }

}

export default new TwilioChannel();
